import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-chevron-right-big",
  "use": "icon-chevron-right-big-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" id=\"icon-chevron-right-big\"><path d=\"m11.4 8-5.1 5.1-.7-.7L10 8 5.6 3.6l.7-.7z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol